const url = '/passengers';
const Provider = 'Passengers';
const dbModel = 'Passengers';
export const TABLE_NAME = 'passengers';

export { url, Provider, dbModel };
